import api from "../config/apiConfig";
import { getAdminId, getRegisterId } from "../utils/authId";
import { toast } from "react-toastify";

export const viewCompanySwitch = async () => {
  const id = getRegisterId();
  try {
    const response = await api.get(
      `api/accessible_company/?register_id=${id}`,
      {}
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchAllCompany = async (data) => {
  const id = getRegisterId();

  try {
    const response = await api.get(
      `api/get_company_with_pagination/?admin_id=${id}${data}`,
      {}
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const addCompanyAdmin = async (formData) => {
  const id = getAdminId();
  const data = {
    ...formData,
    admin: id,
    company_type: "branch",
  };
  try {
    const response = await api.post("api/company_register/", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (response) {
      toast.success("Company Register successful!", {
        position: "top-center",
        autoClose: 2000,
        closeButton: false,
        className: "custom_toast",
      });
    }
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    } else {
      throw new Error(" failed.");
    }
  }
};

export const editCompanyAdmin = async (formData) => {
  try {
    const response = await api.put(
      `api/update_company/${formData.id}/`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    if (response) {
      toast.success("Updated Sucessfully", {
        position: "top-center",
        autoClose: 2000,
        closeButton: false,
        className: "custom_toast",
      });
    }
        return response.data;

  } catch (error) {
    if (error.response) {
      throw error.response.data;
    } else {
      throw new Error("failed.");
    }
  }
};
